import { Chip, styled } from '@mui/material';

export const StyledChip = styled(Chip)`
  border-radius: 4px;
  background: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 20.02px;
    letter-spacing: 0.17px;
  }

  svg {
    fill: ${({ theme }) => theme.palette.primary.contrastText};
    transform: rotateZ(90deg);
    height: 14px;
  }

  &:hover {
    background: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const SmallerChip = styled(StyledChip)`
  position: relative;
  height: 16px;
  border-radius: 2px;
  span {
    font-size: 10px;
    line-height: 16px;
    padding: 0 4px;
    font-weight: 500;
  }

  span {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const LightChip = styled(StyledChip)`
  background: ${({ theme }) => theme.palette.primary.light};
`;
